import { render, staticRenderFns } from "./SelectAdditionalFieldType.vue?vue&type=template&id=76bf3aaa&scoped=true"
import script from "./SelectAdditionalFieldType.vue?vue&type=script&lang=js"
export * from "./SelectAdditionalFieldType.vue?vue&type=script&lang=js"
import style0 from "./SelectAdditionalFieldType.vue?vue&type=style&index=0&id=76bf3aaa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76bf3aaa",
  null
  
)

export default component.exports